import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: var(--color-blue);
  color: #fff;
  padding: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  #logo-container {
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 100px;
      height: auto;
    }

    h1 {
      display: none;
    }
  }

  #admin-nav-container {
    span {
      display: block;
      padding: 4px;
      cursor: pointer;
    }

    span.active {
      text-decoration: underline;
    }
  }

  #store-hello-container {
    display: none;
  }

  #store-hello-container-mobile {
    display: block;
  }

  #logout-button {
    cursor: pointer;
    background-color: var(--color-purple);
    color: #fff;
    text-transform: uppercase;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 8px 16px;
    margin-left: 16px;
    font-size: 1em;
  }

  @media screen and (min-width: 500px) {
    #admin-nav-container {
      span {
        display: inline-block;
        padding: 4px;
      }
    }
  }

  @media screen and (min-width: 768px) {
    padding: 16px 24px;

    #logo-container {
      h1 {
        display: block;
        font-size: 1.6em;
        margin-left: 16px;
        text-transform: uppercase;
        font-weight: 400;
      }
    }

    #admin-nav-container {
      span {
        padding: 8px;
      }
    }

    #store-hello-container {
      display: block;

      h4 {
        font-size: 1.4em;
      }
    }

    #store-hello-container-mobile {
      display: none;
      p {
        font-size: 1.4em;
      }
    }

    #logout-button {
      padding: 8px 24px;
    }
  }

  @media screen and (min-width: 1200px) {
    padding: 16px 32px;

    #logo-container {
      img {
        width: 150px;
      }

      h1 {
        font-size: 2em;
        margin-left: 24px;
      }
    }

    #admin-nav-container {
      span {
        padding: 8px 12px;
      }
    }

    #store-hello-container {
      h4 {
        font-size: 1.6em;
      }
    }

    #logout-button {
      padding: 8px 32px;
    }
  }
`;
